import { render, staticRenderFns } from "./DuplicatePanelPopup.vue?vue&type=template&id=022ff106&"
import script from "./DuplicatePanelPopup.vue?vue&type=script&lang=ts&"
export * from "./DuplicatePanelPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports